// Copyright (C) 2021 Bystronic Laser AG

import { metricsService } from '@/services/metrics.service';
import { BendDeviceStateData } from '../deviceStateData';
import { FilterTimeSpanEnum } from '../enums/FilterTimeSpanEnum';
import { DataRetriever, ProcedureName } from './abstract/chartGenerator';

export default class WorkCenterConsoleOverviewBendingDevicesStateDataRetriever extends DataRetriever<
  BendDeviceStateData[]
> {
  constructor(procedure: ProcedureName, private customerIdDh: number) {
    super(procedure);
  }

  override async getData(
    selectedDevices: string[],
    selectedShifts: number[],
    timeSpan: FilterTimeSpanEnum | [string, string],
  ): Promise<BendDeviceStateData[]> {
    return await metricsService.getBendingDevicesMetrics(
      this.procedure,
      {
        customerIdDh: this.customerIdDh,
        deviceStringIds: selectedDevices,
        shiftIds: selectedShifts,
        timeSpan: timeSpan as FilterTimeSpanEnum,
        // TODO statesOnly?
      },
      this.controller,
    );
  }
}
